import axios from "axios";

export function getApplicationPurpose() {
  return axios.get(process.env.VUE_APP_API_URL + "ApplicationPurpose/getlist");
}

export function postApplicationPurpose(data) {
  return axios.post(
    process.env.VUE_APP_API_URL + "ApplicationPurpose/add",
    data
  );
}

export function updateApplicationPurpose(data) {
  return axios.put(
    process.env.VUE_APP_API_URL + "ApplicationPurpose/update",
    data
  );
}

export function deleteApplicationPurpose(applicationPurposeId) {
  const config = {
    params: {
      applicationPurposeId: applicationPurposeId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "ApplicationPurpose/deleted",
    config
  );
}
